import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
    nextAppointment = {};
}
